<template>
  <div class="w-100">
    <label>{{ $t('security.pinInputText') }}</label>
    <b-form-input
      id="pin"
      ref="pinInput"
      v-model="pin"
      name="pin"
      type="tel"
      v-mask="pinMask"
      pattern="[0-9]"
      :maxlength="pinLength"
      class="pin_mask"
      :placeholder="$t('security.pinPlaceHolder')"
    />
    <b-alert v-show="showPinError" fade show variant="danger">
      <small>{{ $t('security.pinIsInvalid') }}</small>
    </b-alert>
  </div>
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
  name: 'PinInput',
  props: {
    showPinError: Boolean,
    pinLength: Number
  },
  data () {
    return {
      pin: '',
      pinMask: null
      // showPinError: false
    }
  },
  created(){
    var sharp = '#'
    this.pinMask  = `${sharp.repeat(this.pinLength)}`
  },
  methods: {
    showInputError () {
      this.showPinError = true
      setTimeout(() => {
        this.showPinError = false
      }, 5000)
    }
  }
})
</script>
